import { Box, IconButton, Typography, Paper, Link, useTheme } from '@mui/material'
import { FC } from 'react'
import dayjs, { Dayjs } from 'dayjs'

// import LinkRouter from '../LinkRouter'
import { BoxStyle } from './styled'

import { FavoriteBorder } from '@mui/icons-material'

import { useActions } from '../../hooks/useActions'

require('dayjs/locale/uk')

interface Props {
    isProject: boolean,
    urlSlug: string,
    title: string,
    description: string,
    imagePreview: string,
    date: Dayjs,
    announcementTime: string,
    hashtags: Array<string>
}

const AnnouncementItem: FC<Props> = ({ isProject, urlSlug, title, description, imagePreview, date, announcementTime, hashtags }) => {
    const { palette } = useTheme();

    return (
        <Link underline="none" color="unset" href={isProject ? `/projects/${urlSlug}` : `/announcements/${urlSlug}`}>
            <BoxStyle background={isProject ? "#fff" : palette.primary.dark} >
                <Box sx={{ position: "relative", width: { xs: "323px", lg: "279px" }, height: { xs: "190px", lg: "168px" } }}>
                    <img
                        loading="eager"
                        style={{ width: "inherit", height: "inherit", borderRadius: "7px" }}
                        src={imagePreview}
                        alt="image"
                    />
                    <Box sx={{ display: "flex", position: "absolute", bottom: "9px", left: "8px" }}>
                        {hashtags.map((row, index) => {
                            return (
                                <Typography
                                    key={`announcement_hashtag_${index}`}
                                    variant="h6"
                                    fontFamily="Fixel Display, sans-serif"
                                    fontSize={{ xs: "16px", lg: "9px" }} lineHeight={{ xs: "24px", lg: "16px" }}
                                    fontWeight="600"
                                    sx={{

                                        background: palette.primary.main,
                                        borderRadius: "4px",
                                        px: "5px",
                                        mr: "6px"
                                    }}
                                >
                                    {row}
                                </Typography>
                            );
                        })}
                    </Box>
                </Box>
                <Typography
                    variant="h5"
                    fontFamily="Fixel Display, sans-serif"
                    color={isProject ? palette.primary.dark : "inherit"}
                    fontWeight="800"
                    sx={{
                        fontSize: { xs: "h4.fontSize", lg: "h5.fontSize" },
                        lineHeight: { xs: "28px", lg: "24px" },
                        fontWeight: { xs: "700", lg: "800" },
                        height: { xs: "84px", lg: "72px" },
                        mt: "8px"
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="h6"
                    fontFamily="Fixel Display, sans-serif"
                    fontSize={{ xs: "18px", lg: "12px" }}
                    lineHeight={{ xs: "24px", lg: "15px" }}
                    color={isProject ? palette.background.default : palette.text.secondary}
                    sx={{
                        height: { xs: "48px", lg: "30px" },
                        mt: { xs: "0px", lg: "4px" }
                    }}
                >
                    {description}
                </Typography>
                <Typography
                    variant="h6"
                    fontFamily="Fixel Display, sans-serif"
                    color={isProject ? palette.primary.dark : "inherit"}
                    fontWeight="600"
                    sx={{
                        fontSize: { xs: "h4.fontSize", lg: "h6.fontSize" },
                        lineHeight: { xs: "28px", lg: "24px" },
                        fontWeight: { xs: "700", lg: "800" },
                        height: { xs: "28px", lg: "24px" },
                        mt: { xs: "20px", lg: "17px" }
                    }}
                >
                    {dayjs(date).locale('uk').format('DD MMMM')} {announcementTime}
                </Typography>
            </BoxStyle>
        </Link >

    )
}

export default AnnouncementItem;